import "../../../stylesheets/components/forms/messages.scss";

function ErrorMessage(props) {
    return (
        <p className="mt-3 error-msg">{props.children}</p>
    )
}

export default ErrorMessage